import { supabase } from "../supabaseClient";

async function submitBookingForm(obj) {
	const { data, error } = await supabase.from("BookingForm").insert(obj).select();
	if (data) return data;
	else throw error;
}

async function updateAllotmentPayment(obj, id) {
	const { data, error } = await supabase.from("AllotmentPayment").update(obj).eq("allotmentPaymentId", id);
	if (data) return data;
	else throw error;
}

async function updatePersonTable(name, personId) {
	const { data, error } = await supabase
		.from('Person')
		.update({ name: name })
		.eq('personId', personId);
	if (data) return data;
	else throw error;
}

export { submitBookingForm, updateAllotmentPayment, updatePersonTable };
